import { School } from '../containers/props/School.types'

export enum SchoolStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export enum SchoolGenders {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  COEDUCATIONAL = 'COEDUCATIONAL',
}

export enum SchoolSectors {
  INDEPENDENT = 'INDEPENDENT',
  GOVERNMENT = 'GOVERNMENT',
  CATHOLIC = 'CATHOLIC',
}

export enum SchoolSearchTextBoxMenuItemType {
  LOCALITY = 'LOCALITY',
  SCHOOL = 'SCHOOL',
  STATE = 'STATE',
}

export enum SchoolAutoSuggestType {
  LOCALITY = 'LOCALITY',
  SCHOOL = 'SCHOOL',
  STATE = 'STATE',
}

export type OverrideMenuSelectEvent = {
  locality?: { state?: string; suburb?: string }
  state?: string
  school?: School
}
